import * as React from 'react';

function SkillSetBadge(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={69} height={120} viewBox="0 0 69 120" fill="none" {...props}>
      <path
        d="M2.6 57.997V21.35L34.016 3.031 65.432 21.36v36.638l-31.416 18.32L2.6 57.996z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 19.838L34.016 0 68 19.838v39.677L34.016 79.353 0 59.507V19.838zm62.816 3.03l-28.8-16.8-28.8 16.8v33.609l28.8 16.808 28.8-16.8V22.869z"
        fill="var(--cds-color-yellow-300)"
      />
      <path
        d="M62.817 22.909l5.216-3.071v39.677l-5.224-3.047.008-33.56zM0 59.508l5.16-3.063 28.904 16.857-.048 6.044L0 59.508zM5.184 22.86L0 19.839 34.016 0l-.032 6.02-28.8 16.84z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        d="M34.016 23.645l5.152 10.553 11.536 1.689-8.344 8.218 1.968 11.596-10.312-5.47-10.312 5.47 1.968-11.596-8.344-8.218 11.528-1.689 5.16-10.553z"
        fill="var(--cds-color-yellow-200)"
        stroke="var(--cds-color-yellow-300)"
        strokeWidth={1.616}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SkillSetBadge;
